/**
 * All available routes within the device-ui/shell
 */
export enum DeviceUiRoute {
	Channels = 'channels',
	Intellimix = 'intellimix',
	Presets = 'presets',
	Settings = 'settings',
	Schematic = 'schematic',
	Inputs = 'inputs',
	Matrixmixer = 'matrix-mixer',
	Outputs = 'outputs',
	Coverage = 'coverage',
	CoverageNext = 'coverage-next',
	Loudspeaker = 'loudspeaker',
	ChargerBays = 'charger-bays',
	DirectChannels = 'direct-channels',
	DspSettings = 'dsp-settings'
}
